var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "none",
  points: "19.5,26.5 19.4,26.3 17.9,27.8 19,28.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "none",
  points: "15.3,25.2 17.7,24.7 17.2,24.2 17,24 14.1,24  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "none",
  points: "18.5,25.5 16.1,26 17.2,27.1 18.7,25.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "none",
  points: "20.8,27.8 20.3,27.3 19.9,29.8 21,30.9 21,28  "
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A1A1A1",
  d: "M19,24.6l1.4,1.4c0.1,0,0.1,0.1,0.1,0.1l0.6,0.6l0.7-0.7c0.1-0.1,0.2-0.2,0.2-0.3c0-0.2-0.1-0.3-0.2-0.4 l-2.1-2.1c-0.2-0.2-0.5-0.2-0.7,0l-0.7,0.7L19,24.6C18.9,24.5,19,24.6,19,24.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M7.5,26.4c0,0.2,0.1,0.3,0.3,0.4h0.5l4.4-2.8l1.5,1.5l-4,2.9C10,28.5,10,28.7,10,28.9 c0,0.2,0.1,0.3,0.3,0.4h0.5l4.1-3.1l1.6,1.6L13,31.3c-0.1,0.1-0.2,0.3-0.2,0.5c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0,0.4-0.1,0.5-0.2 l3.5-3.5l1.6,1.6l-3.1,4.1c-0.1,0.2-0.1,0.6,0.2,0.7c0.2,0.2,0.5,0.1,0.7-0.1l2.9-4l1.5,1.5l-2.8,4.4c-0.1,0.1-0.1,0.4,0,0.5 c0.1,0.2,0.2,0.3,0.4,0.3l0.5-0.2l2.8-4.6c0-0.1,0.1-0.2,0.1-0.3v-4.6c0-0.1-0.1-0.3-0.2-0.4l0.7-0.7c0.3-0.2,0.5-0.6,0.5-1 c0-0.4-0.2-0.8-0.5-1.1l14.6-14.5c0.5-0.6,0.5-1.6,0-2.2c-0.3-0.2-0.7-0.4-1.1-0.4c-0.4,0-0.8,0.2-1.1,0.4L20.4,22.5 c-0.3-0.3-0.7-0.5-1.1-0.5c-0.4,0-0.8,0.2-1,0.5l-0.7,0.7L17.2,23h-4.6l-0.3,0.1l-4.6,2.8C7.6,26,7.5,26.2,7.5,26.4z M16.1,26 l2.4-0.5l0.2,0.2l-1.5,1.5L16.1,26z M17.9,27.8l1.5-1.5l0.2,0.2L19,28.9L17.9,27.8z M21,30.9l-1.1-1.1l0.5-2.4l0.5,0.5L21,28V30.9z  M35.6,8.6c0.3-0.1,0.5-0.1,0.8,0c0.1,0.3,0.1,0.5,0,0.8L21.8,23.9l-0.7-0.7L35.6,8.6z M19,23.2c0.2-0.2,0.5-0.2,0.7,0l2.1,2.1 c0.1,0.1,0.2,0.2,0.2,0.4c0,0.1-0.1,0.2-0.2,0.3l-0.7,0.7l-0.6-0.6c0-0.1-0.1-0.1-0.1-0.1L19,24.6c0,0,0,0,0,0l-0.6-0.6L19,23.2z  M17,24l0.2,0.2l0.5,0.5l-2.4,0.5L14.1,24H17z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A1A1A1",
  d: "M21.1,23.2l0.7,0.7L36.4,9.4c0.1-0.3,0.1-0.5,0-0.8c-0.3-0.1-0.5-0.1-0.8,0L21.1,23.2z"
}));

function SvgRake(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRake);
export default __webpack_public_path__ + "static/media/rake.f94f981501c0af7678a7fee00fd01e8a.svg";
export { ForwardRef as ReactComponent };